"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("es6-promise");
require("lazysizes");
require("modernizr");
require("picturefill");
require("url-search-params-polyfill");
require("../Scripts/cropper-jquery-plugin");
//
// LIST OF ALL CUSTOM COMPONENTS TO BE INITIALIZED ON PAGELOAD
require("../Views/Partials/Components/Anchor");
require("../Views/Partials/Components/CaseStudies");
require("../Views/Partials/Components/CaseStudy");
require("../Views/Partials/Components/FileLinkCheckerComponent");
require("../Views/Partials/Components/Header");
require("../Views/Partials/Components/HeroBanner");
require("../Views/Partials/Components/HeroBanner/HeroBanner.Home");
require("../Views/Partials/Components/ImageFallback");
require("../Views/Partials/Components/KeepTheRhythm");
require("../Views/Partials/Components/QuickLinkList");
require("../Views/Shared/Components/RichTextEditor");
require("../Views/Partials/Components/SafetyValveCertificates");
require("../Views/Partials/Components/ScrollToTopButton");
require("../Views/Partials/Components/ServiceWorkers");
require("../Views/Partials/Components/SocialMediaLinkCheckerComponent");
require("../Views/Partials/Components/Table");
require("../Views/Partials/Components/Tabs");
require("../Views/Partials/Components/Tabs/sticky.tabs");
require("../Views/Partials/Components/Tile/Tile.Range");
require("../Views/Partials/Components/TileGroup");
require("../Views/Partials/Components/UmbracoFormsCustomComponents");
require("../Views/Partials/Components/WebAnalyticsComponent");
require("../Views/Shared/Components/ExpandCollapse");
require("../Views/Shared/Components/FullBleedImageSpot");
require("../Views/Shared/Components/LearningComponent");
require("../Views/Shared/Components/Media");
require("../Views/Shared/Components/NewsletterSignup");
require("../Views/Shared/Components/PodcastComponent");
require("../Views/Shared/Components/SliderComponent");
require("../Views/Shared/Components/Spot");
require("../Views/Shared/Components/Spot/Spot.PlayVideo");
require("../Views/Shared/Components/Spot/Spot.RenderPreview");
require("../Views/Shared/Components/Spot/Spot.ShowPopupImage");
require("../Views/Shared/Components/SpotGroup");
var main_1 = require("./main");
require("./polyfills/closest");
require("./polyfills/object.assign");
main_1.default();
